import { render, staticRenderFns } from "./meeting-tab.vue?vue&type=template&id=2745496c&"
import script from "./meeting-tab.vue?vue&type=script&lang=js&"
export * from "./meeting-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports